import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { AnnouncementItem } from 'components/shared/announcementPicker/adapters/announcementAdapter';

import type { BusinessHourSchedule } from './types/businessHourSchedule';
import type { HolidayState } from './types/holidays';

type Schedule = BusinessHourSchedule[];
type Announcement = AnnouncementItem | null;
type IntervalsErrors = (null | string)[][];

type Setters = {
  setAnnouncement: Dispatch<SetStateAction<Announcement>>;
  setHolidays: Dispatch<SetStateAction<HolidayState>>;
  setIntervalsErrors: Dispatch<SetStateAction<IntervalsErrors>>;
  setName: Dispatch<SetStateAction<string>>;
  setSchedule: Dispatch<SetStateAction<Schedule>>;
};

export type MigrateOpeningHoursContext = {
  schedule: Schedule;
  holidays: HolidayState;
  intervalsErrors: IntervalsErrors;
  announcement: Announcement;
  name: string;
  timezone: string;
  setters: Setters;
  step: number;
  onCancel: VoidFunction;
  onNextStep: VoidFunction;
};

export const MigrateOpeningHoursContext =
  createContext<MigrateOpeningHoursContext | null>(null);

export const useMigrateOpeningHoursContext = (): MigrateOpeningHoursContext => {
  const context = useContext(MigrateOpeningHoursContext);

  if (!context) {
    throw new Error('No MigrateOpeningHoursContext');
  }

  return context;
};
